<template>
  <application-layout>
    <v-main>
      <v-container>
        <h1>Manage Facilities</h1>

        <v-btn
          data-testid="facility-index-create-btn"
          class="facility-index-create-btn mb-4 ml-0"
          color="primary"
          @click="resetCurrentFacility"
        >
          <v-icon>add</v-icon>
          Add New Facility
        </v-btn>

        <v-data-table
          :footer-props="{
            ...footerProps,
            itemsPerPageOptions: pagination.rowsPerPageOptions,
          }"
          :headers="headers"
          :items="facilities"
          :loading="loading"
          :options.sync="pagination"
          :server-items-length="pagination.totalItems"
        >
          <template v-slot:body="{ items }">
            <transition-group
              name="scroll-y-transition"
              tag="tbody"
              v-if="items.length"
            >
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.location_code }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.street_address }}</td>
                <td>{{ item.city }}</td>
                <td>{{ item.state }}</td>
                <td>
                  <v-btn
                    data-testid="facility-index-edit-btn"
                    class="facility-index-edit-btn ml-0 mr-3"
                    small
                    color="primary"
                    :to="{ name: 'facilitiesEdit', params: { facilityId: item.id } }"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    data-testid="facility-index-delete-btn"
                    class="facility-index-delete-btn ml-0"
                    color="error"
                    small
                    @click="openDelete(item)"
                  >
                    Delete
                  </v-btn>
                </td>
              </tr>
            </transition-group>
            <tr v-else>
              <td colspan="12" style="text-align: center">
                No facilities found.
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
    <delete-modal
      v-model="modal"
      @delete="deleteFacilityPage"
      :itemType="'facility'"
      :advisory="advisory"
    />
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import { facilityHeaders } from "@/helpers/facility/facility-data-table-headers";
import { footerProps } from "@/helpers/footer-props";
import { genericAdvisory } from "@/helpers/warning-advisory-text";

export default {
  data() {
    return {
      advisory: genericAdvisory,
      footerProps: footerProps,
      headers: facilityHeaders,
      loading: true,
      modal: false,
      selectedFacility: ""
    };
  },

  computed: {
    facilities() {
      return this.$store.state.facility.facilities;
    },
    pagination: {
      get() {
        return this.$store.state.facility.pagination;
      },
      set(newValue) {
        this.$store.commit("setFacilityPagination", newValue);
      }
    }
  },

  components: {
    ApplicationLayout,
    DeleteModal
  },

  watch: {
    pagination: {
      handler() {
        this.loading = true;
        this.$store.dispatch("getAllFacilities")
          .then(() => {
            this.loading = false;
          });
      },
      deep: true
    }
  },

  methods: {
    openDelete(facility) {
      this.modal = true;
      this.selectedFacility = facility;
    },

    async deleteFacilityPage() {
      await this.$store.dispatch("deleteFacility", this.selectedFacility.id);
      this.selectedFacility = "";
      this.modal = false;
    },
    resetCurrentFacility() {
      this.$store.commit("resetCurrentFacility");
      this.$router.push({ name: "facilitiesCreate" });
    }
  }
};
</script>
